import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

/***
 * @deprecated
 * Don't use it in the new code. This is just a workaround.
 * Since ngx-perfect-scrollbar package is no longer maintained, it's removed from the platform.
 * And due to wide usage of this component there was implemented this workaround instead.
 * But eventually it must be removed from everywhere.
*/
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'perfect-scrollbar',
  template: `
    <div #scrollable class="ps">
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./perfect-scrollbar.component.scss'],
  standalone: false,
})
export class PerfectScrollbarComponent implements OnInit {
  @ViewChild('scrollable', { static: true })
  private scrollable: ElementRef<HTMLElement>;

  directiveRef: {
    elementRef: ElementRef<HTMLElement>;
    scrollToElement: (selector: string) => void
    scrollToBottom: (offset?: number, speed?: number) => void,
    scrollTo: (xCoordinate: number, yCoordinate?: number) => void
  };
  @Input()
  config: any;
  @Input()
  scrollIndicators: boolean;
  @Input()
  disabled: boolean;
  @Input()
  autoPropagation: boolean;

  ngOnInit(): void {
    this.directiveRef = {
      elementRef: this.scrollable,
      scrollToElement: (selector) => this.scrollable.nativeElement.querySelector(selector).scrollTo(),
      scrollToBottom: () => this.scrollable.nativeElement.scrollTo(0, this.scrollable.nativeElement.scrollHeight),
      scrollTo: (xCoordinate: number, yCoordinate: number) => this.scrollable.nativeElement.scrollTo(xCoordinate, yCoordinate)
    };
  }
}
// TODO: TO IMPLEMENT!!!!
